import { useCallback } from "react";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { useSiteControllerSettingAirHost } from "../../../../model/air-host/use-case/use-update-site-controller-setting-air-host";

import type { SiteControllerSettingAirHostFormModel } from "../../../../model/air-host/type";

type Props = {
	viewModel: SiteControllerSettingAirHostFormModel["ViewModel"];
	onResetViewModel: () => void;
};

export const useSettingsSiteControllerAirHost = ({ viewModel, onResetViewModel }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { onUpdate: _onUpdate } = useSiteControllerSettingAirHost({ viewModel });

	const onUpdate = useCallback(async () => {
		showLoadingScreenCallback();

		const { errors } = await _onUpdate().finally(hideLoadingScreenCallback);

		if (!errors) {
			notifyUserEventInfo({
				title: "サイコン設定（AirHost）を更新しました",
			});

			onResetViewModel();
		}
	}, [_onUpdate, hideLoadingScreenCallback, onResetViewModel, showLoadingScreenCallback]);

	return {
		onUpdate,
	};
};
